<template>
    <div class="checkout-guarantee">
        <div>
            <p class="checkout-guarantee">
                <svg>
                    <use xlink:href="#svg-completed"></use>
                </svg>
                {{ messages.warranty }}
            </p>
            <p class="checkout-guarantee">
                <svg>
                    <use xlink:href="#svg-arrow-return"></use>
                </svg>
                {{ messages.exchangeAndReturn }}
            </p>
        </div>

    </div>
</template>

<script>
import {mapState} from 'vuex';
import DefProgramMe from "../../def/DefProgramMe/DefProgramMe";

export default {
    name: 'CheckoutGuarantee',
    props: ['result'],
    components: {
        DefProgramMe,
    },
    computed: {
        ...mapState({
            messages: ({results}) => results?.storeInformation.messages,
        }),
    },
}
</script>

<style lang="scss" scoped>
.checkout-guarantee {
    &__item {
        display: flex;
        align-items: center;
        font-size: rem(14);
        line-height: 110%;
        color: #757575;
        @include point-md {
            font-size: rem(16);
        }

        &:not(:last-child) {
            margin-bottom: 16px;
        }

        svg {
            width: 16px;
            height: 16px;
            margin-right: 8px;
        }
    }
}
</style>